import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import dayjs from "dayjs";
import BrianyCareLogo from "../../assets/auth/BrainyCare-Logo.jpg";
import DrMadhuSign from "../../assets/imaging/madhusign.png";
import { allowedUsers } from '../allowedUsers';
import axios from "axios";
import { getPracticeId } from "../../config/practice";

const EchoView = () => {
  const { filename } = useParams();
  const [examData, setExamData] = useState(null);

  // Fetch data from API
  const fetchData = async () => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/v1/${getPracticeId()}/imaging/get-image/id`,
        { row_id: parseInt(filename, 10) }
      );

      if (response?.data?.data[0]) {
        const raw = response.data?.data[0];
        const parsedData = JSON.parse(raw.data);
        setExamData(parsedData);
      }
    } catch (error) {
      console.error("Error fetching exam data:", error);
    }
  };

  useEffect(() => {
    if (filename) fetchData();
  }, [filename]);

  // Safe access to formData
  const mitral = examData?.mitral || {};
  const tricuspid = examData?.tricuspid || {};
  const technicianComments = examData?.technicianComments || {};

  const mModeKeys = [
    { key: 'mvde', label: 'MV D-E' },
    { key: 'aodia', label: 'AO DIA' },
    { key: 'aoex', label: 'AO EX' },
    { key: 'ladim', label: 'LA DIM' },
    { key: 'rvdim', label: 'RV DIM' },
    { key: 'ivsthick', label: 'IVS THICK' },
    { key: 'ivsexcur', label: 'IVS EXCUR' },
    { key: 'pwthick', label: 'PW THICK' },
    { key: 'pwexcur', label: 'PW EXCUR' },
    { key: 'ladiadim', label: 'LV DIA DIM' },
    { key: 'lasysdim', label: 'LV SYS DIM' },
    { key: 'ef', label: 'EF (%)' }
  ];

const valveFields = {
  mitral: [
    { key: 'mM2D', label: 'M-M/2D' },
    { key: 'regurge', label: 'REGURGE' },
    { key: 'stenosis', label: 'STENOSIS' },
    { key: 'flowE', label: 'FLOW (E wave)' },
    { key: 'flowA', label: 'FLOW (A wave)' },
    { key: 'pressTime', label: 'PRESS(½ TIME)' },
    { key: 'pressDecelTime', label: 'PRESS(Decel TIME)' },
    { key: 'mva', label: 'MVA' }
  ],
  aortic: [
    { key: 'mM2D', label: 'M-M/2D' },
    { key: 'regurge', label: 'REGURGE' },
    { key: 'stenosis', label: 'STENOSIS' },
    { key: 'flow', label: 'FLOW' },
    { key: 'maxPG', label: 'MAX PG' },
    { key: 'meanPG', label: 'MEAN PG' },
    { key: 'ava', label: 'AVA' }
  ],
  tricuspid: [
    { key: 'mM2D', label: 'M-M/2D' },
    { key: 'regurge', label: 'REGURGE' },
    { key: 'flow', label: 'FLOW' },
    { key: 'trGradient', label: 'TR GRADIENT' },
    { key: 'paPressure', label: 'PA PRESSURE' }
  ],
  pulmonic: [
    { key: 'mM2D', label: 'M-M/2D' },
    { key: 'regurge', label: 'REGURGE' }
  ],
  technicianComments: [
    { name: 'trivialAorticInsufficiency', label: 'TRIVIAL AORTIC INSUFFICIENCY' },
    { name: 'noWallMotionAbnormalities', label: 'NO WALL MOTION ABNORMALITIES' },
    { name: 'normalEjectionFraction', label: 'NORMAL EJECTION FRACTION - 65%' },
    { name: 'normalVentricularThickness', label: 'NORMAL VENTRICULAR THICKNESS' },
    { name: 'normalDiastolicFunction', label: 'NORMAL DIASTOLIC FUNCTION' },
    { name: 'sizeChambers', label: 'NORMAL SIZE CHAMBERS' },
    { name: 'pulmonaryPressure', label: 'NORMAL PULMONARY ARTERY PRESSURE' },
    { name: 'pericardialEffusion', label: 'NO PERICARDIAL EFFUSION' },
    { name: 'intracavitaryMass', label: 'NO INTRACAVITARY MASS OR THROMBUS' }
  ]
};

  
  return (
    <div id={examData ? "report-ready" : undefined} className="p-6 bg-white min-h-screen w-full flex justify-center items-center">
      <div className="w-full max-w-4xl flex flex-col border border-gray-300 rounded-md p-8 shadow-sm bg-white">
        {/* Header */}
        {/* <div className="flex items-start w-full justify-center mb-4">
          <img src={BrianyCareLogo} alt="Logo" className="w-16 h-16 mr-3" />
          <div>
            {/* <h1 className="text-xl font-bold text-start text-blue-600 leading-none">C-HIM</h1> */}
            {/*<h1 className="text-sm font-semibold mt-1">Center for Hypertension & Internal Medicine</h1>

            <p className="text-sm font-semibold mt-1">420 E. 6th St. Suite 107</p>
            <p className="text-sm font-semibold mt-1">Odessa, TX 79761</p>
            <p className="text-sm font-semibold mt-1">Phone: 432-582-2446 * Fax: 432-582-2960</p>
          </div>
        </div> */}

<div className="flex items-center w-full justify-center">
  {/* Logo */}
  <img
    src={BrianyCareLogo}
    alt="Center for Hypertension & Internal Medicine"
    className="w-16 h-16 mr-4 flex-shrink-0"
  />

  {/* Text Content */}
  <div className="text-left">
    <h1 className="text-[1.5rem] font-semibold leading-tight">
      CENTER FOR HYPERTENSION <br/>& INTERNAL MEDICINE
    </h1>
  </div>
</div>
  <div className="text-center mb-6">
    <p className="text-sm font-medium mt-1">807 N Hancock Ave, Odessa, TX 79761</p>
    <p className="text-sm font-medium mt-1">Ph: 432-582-2446 &nbsp;|&nbsp; Fax: 432-582-2960</p>
  </div>


        {/* Title */}
        <h2 className="text-center font-bold text-base mb-4">TRANSTHORACIC ECHOCARDIOGAPHY</h2>

        {examData ? (
          <>
            {/* Render Patient Info */}
            <div className="flex justify-start text-sm text-left w-full mb-4">
              <div className="grid grid-cols-[auto_20px_1fr] gap-x-2 gap-y-1">
                <span><strong>MR No#</strong></span><span>:</span><span>{examData.patient_id}</span>
                <span><strong>Name</strong></span><span>:</span><span>{examData.pat_name}</span>
                <span><strong>Age</strong></span><span>:</span><span>{examData.pat_age}</span>
                <span><strong>Exam Date</strong></span><span>:</span><span>{dayjs(examData.examDate).format("MM, DD, YYYY")}</span>
                <span><strong>Date of Birth</strong></span><span>:</span><span>        
                  {dayjs(examData.pat_dob).format("MMM D, YYYY")}
                </span>
                <span><strong>Patients History</strong></span><span>:</span><span>{examData.pathistory}</span>
              </div>
            </div>

            {/* Form data view */}
            <div className="w-full text-start mb-6 text-sm">
              <div className="grid grid-cols-2">
                <div className="mt-2"><strong>Take:</strong> {examData.take || ''}</div>
                <div className="mt-2"><strong>Tape:</strong> {examData.tape || ''}</div>
              </div>
              <div className="grid grid-cols-2">
                <div className="mt-2"><strong>Registered by:</strong> {examData.registeredby || ''}</div>
                <div className="mt-2"><strong>Technician:</strong> {examData.technician || ''}</div>
              </div>
            </div>

            {/* M-Mode Table */}
            <div className="w-full">
              <div className="text-start"><strong>M-Mode:</strong></div>
              <div className="overflow-x-auto">
                <table className="min-w-full table-auto border-separate border-spacing-0 border border-gray-300">
                  <thead>
                    <tr>
                      {mModeKeys.map(({ label }) => (
                        <th key={label} className="border p-1 text-center text-xs text-gray-500">{label}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      {mModeKeys.map(({ key }) => (
                        <td key={key} className="border p-1 text-center text-xs text-gray-500">
                          {examData.mMode?.[key] || '-'}
                        </td>
                      ))}
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            {/* Mitral Valve Section */}
<div className="py-8">
  <div className="grid grid-cols-2 gap-6 mb-2">
    {/* Render the Mitral Valve Section */}
    <div className="border p-3">
      <h6 className="text-start text-xl font-semibold mb-2">MITRAL VALVE</h6>
      <div className="space-y-4">
        {valveFields.mitral.map(({ key, label }) => (
          <div key={key} className="flex justify-between items-center">            
            <span className="text-sm text-gray-500">{label}</span>
            <span className="font-medium text-gray-700">{mitral[key] || '-'}</span>
          </div>
        ))}
      </div>
    </div>

    {/* Render the Aortic Valve Section */}
    <div className="border p-3">
      <h6 className="text-start text-xl font-semibold mb-2">AORTIC VALVE</h6>
      <div className="space-y-4">
        {valveFields.aortic.map(({ key, label }) => (
          <div key={key} className="flex justify-between items-center">            
            <span className="text-sm text-gray-500">{label}</span>
            <span className="font-medium text-gray-700">{examData.aortic[key] || '-'}</span>
          </div>
        ))}
      </div>
    </div>
  </div>

  <div className="grid grid-cols-2 gap-6 mb-2">
    {/* Render the Tricuspid Valve Section */}
    <div className="border p-3">
      <h6 className="text-start text-xl font-semibold mb-2">TRICUSPID VALVE</h6>
      <div className="space-y-4">
        {valveFields.tricuspid.map(({ key, label }) => (
          <div key={key} className="flex justify-between items-center">            
            <span className="text-sm text-gray-500">{label}</span>
            <span className="font-medium text-gray-700">{tricuspid[key] || '-'}</span>
          </div>
        ))}
      </div>
    </div>

    {/* Render the Pulmonic Valve Section */}
    <div className="border p-3">
      <h6 className="text-start text-xl font-semibold mb-2">PULMONIC VALVE</h6>
      <div className="space-y-4">
        {valveFields.pulmonic.map(({ key, label }) => (
          <div key={key} className="flex justify-between items-center">            
            <span className="text-sm text-gray-500">{label}</span>
            <span className="font-medium text-gray-700">{examData.pulmonic[key] || '-'}</span>
          </div>
        ))}
      </div>
    </div>
  </div>

  {/* Technician's Comments Section */}
  {/* <div className="border p-3 mt-4">
    <h6 className="text-start text-xl font-semibold mb-2">TECHNICIAN'S CONCLUSIONS AND COMMENTS</h6>
    <div className="space-y-4">
      {valveFields.technicianComments.map(({ name, label }) => (
        <div key={name} className="flex pt-2">
          <span className="font-medium text-gray-700 w-[50%] text-start">{technicianComments[name] || '-'}</span>
          <span className="text-bold text-start text-gray-500 w-[50%]">{label}</span>
        </div>
      ))}
    </div>
  </div> */}

<div className="border p-3 mt-4">
  <h6 className="text-start text-xl font-semibold mb-2">
    {allowedUsers.includes(examData?.createdby) ? (
      <div>IMPRESSIONS</div>
    ) : (
      <div>TECHNICIAN'S CONCLUSIONS AND COMMENTS</div>
    )}
    </h6>
  <div className="space-y-4">
    {Object.keys(technicianComments).map((name) => {
      const comment = technicianComments[name];

      if (!comment?.text) return null;
      return (
        <div key={name} className="flex pt-2">
          {/* Render the dropdown value from technicianComments on the left */}
          {/* <span className="font-medium text-gray-700 w-[50%] text-start">
            {comment?.dropdown || '-'}
          </span> */}
          
          {/* Render the text data from technicianComments on the right */}
          <span className="font-medium text-gray-700 text-start">
            {comment?.text}
          </span>
        </div>
      );
    })}
  </div>
</div>

</div>


        {examData ? (
                  <>
            <div className="py-8">
              <div className="flex justify-between items-center">
                <div>
                    {examData?.signoff && (
                      <>
                        <img src={DrMadhuSign} alt="Signed Off" className="ml-2 h-20 inline-block" />
                        <div className="font-semibold">Dr. Madhu Pamganamamula MD FACP FASPC DABOM DABCL CCD</div>
                      </>
                    )}                    
                </div>
              </div>
            </div>
        </>
        ) : (
         <></>
        )}


          </>
        ) : (
          <p className="text-center text-gray-500">Loading...</p>
        )}
      </div>
    </div>
  );
};

export default EchoView;